export default () => ({
  errorTrue: false,
  mobileMenuOn: false,
  entity: 'term',
  entities: 'terms',
  currentEntity: {},
  terms: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/auth/terms/term/resources/data.js